<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-demo__news">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.title" placeholder="请输入任务名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="goJumpQuery(`taskDetail`, { id: 0 })">添加</el-button>
                </el-form-item>
                <!--                <el-form-item>-->
                <!--                    <el-button type="danger" @click="deleteHandle()">删除</el-button>-->
                <!--                </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                @sort-change="dataListSortChangeHandle" style="width: 100%">
                <!--                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <el-table-column prop="id" label="任务编号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="taskName" label="任务名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="taskType" label="任务类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType== '1'">就业调查</span>
                        <span v-if="scope.row.taskType== '2'">走访入户</span>
                        <span v-if="scope.row.taskType== '3'">文体活动</span>
                    </template>
                </el-table-column>
                <el-table-column prop="organization" label="发布任务机构" header-align="center" align="center"></el-table-column>
                <el-table-column prop="creator" label="发布任务人" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDate" label="发布时间" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" fixed="right" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small"
                            @click="goJumpQuery(`taskDetail`, { id: scope.row.id })">修改</el-button>
                        <el-button type="text" size="small"
                            @click="lookOver(scope.row.id, scope.row.taskType)">查看关联</el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <!-- <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update> -->
            <!-- 查看关联-->
            <view-association v-if="OpenViewAssociation" ref="ViewAssociation"
                @refreshDataList="getDataList"></view-association>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./list-add-or-update";
import ViewAssociation from "./view-association";
export default {
    mixins: [mixinViewModule],
    components: {
        AddOrUpdate,
        ViewAssociation,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/task/list",
                getDataListIsPage: true,
                deleteURL: "/demo/news",
                deleteIsBatch: true,
                createdIsNeed: true,
            },
            daterange: null,
            dataForm: {
                title: "",
                startDate: "",
                endDate: "",
                area: JSON.parse(localStorage.getItem('org')).area || ''
            },
            OpenViewAssociation: false,
        };
    },
    watch: {
        daterange(val) {
            if (val == null) {
                this.dataForm.startDate = null;
                this.dataForm.endDate = null;
            } else {
                this.dataForm.startDate = val[0];
                this.dataForm.endDate = val[1];
            }
        },
    },
    methods: {
        lookOver(id, taskType) {
            //查看任务关联
            this.OpenViewAssociation = true;
            this.$nextTick(() => {
                // this.$refs.ViewAssociation.dataForm.taskId = String(id);
                if (taskType == "3") {
                    this.$refs.ViewAssociation.mixinViewModuleOptions.getDataListURL =
                        "/task/resultList";
                } else {
                    this.$refs.ViewAssociation.mixinViewModuleOptions.getDataListURL =
                        "/task/relateList";
                }
                this.$refs.ViewAssociation.dataForm.taskType = taskType;
                this.$refs.ViewAssociation.init(id);
            });
        },
        deleteHandle(rowID) {
            //删除任务
            this.$confirm('确定进行删除操作？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios.get(
                    this.$baseURL+"/api/task/delete",
                    {
                        params: {
                            id: rowID
                        }
                    },
                    { headers: { "content-type": "application/json" } }
                )
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.query()
                            }
                        })
                    })
                    .catch(() => { });
            }).catch(() => { })
        }
    },
};
</script>
